export enum ApiV1NaturalPartyTypeEnumCodeEnum {
    Driver = 'IDVR',
    Contact = 'ACPN',
    Witness = 'WTNS',
    CoInsured = 'MEDE',
    ClaimReporter = 'MELD',
    Normal = 'NRML',
    Counterparty = 'TEGE',
}
